import React from "react";
import { Card } from "react-bootstrap";
function DataDeletion() {
  return (
    <Card>
      <Card.Header>
        Facebook-р бүртгүүлсэн хэрэглэгч TodToli-с өөрий мэдээллээ устгуулах
      </Card.Header>
      <Card.Body>
        <Card.Title>
          Хэрэглэгч Facebook ашиглан бүртгүүлсэн мэлээллээ TodToli-с устгуулахын
          тулд доорх үйлдэлүүдийг хийнэ:
        </Card.Title>
        <ul>
          <li>
            <Card.Text>
              TodToli-д бүртгүүлсэн Facebook хаягаараа Facebook-т нэвтрэх.
            </Card.Text>
          </li>
          <li>
            <Card.Text>
              <a href="https://www.facebook.com/todtoli">Энд дарж</a>{" "}
              TodToli-ийн Facebook хуудасруу орох.
            </Card.Text>
          </li>
          <li>
            <Card.Text>
              Хуудасны шат хэсгийг ашиглаж бүртгэлээ устгуулах хүсэлт илгээнэ.
            </Card.Text>
          </li>
          <li>
            <Card.Text>
              Хэрэглэгчийн гаргасан хүсэлтийг бид 24 цагийн дотор шийдвэрлэж
              хариу мэдэгдэнэ.
            </Card.Text>
          </li>
        </ul>
      </Card.Body>
    </Card>
  );
}
export default DataDeletion;
